/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { ActionsObservable, combineEpics, StateObservable } from 'redux-observable';
import { empty, of, timer } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { catchError, expand, filter, map, switchMap, throttleTime } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';
import { getWmps, throttledGetWmps } from '.';
import { AppAction, AppState } from '..';
import config from '../../config';
import { Wmp } from '../../db/stores/wmps';
import { getCommonHeaders } from '../../utils/epics';
import { PagedResponse } from '../../utils/types';
import { fetchTokenActions } from '../session';
import { FIVE_MINUTES } from "../../utils/time";

const throttledGetWmpsEpic = (action$: ActionsObservable<AppAction>, state$: StateObservable<AppState>) => {
  return action$.pipe(
    filter(isActionOf([throttledGetWmps, fetchTokenActions.success])),
    throttleTime(FIVE_MINUTES),
    map(getWmps.request)
  )
}

const getWmpsEpic = (action$: ActionsObservable<AppAction>, state$: StateObservable<AppState>) => {
  return action$.pipe(
    filter(isActionOf(getWmps.request)),
    switchMap(() => timer(0, 8.64e7)),
    switchMap(() => {
      const headers = getCommonHeaders(state$);
      return ajax.get(`${config.dfdmHost}/api/wmps?max=100&eval_client=true`, headers).pipe(
        expand((resp) => {
          const response: PagedResponse<Wmp> = resp.response;
          if (!response || !response.next) {
            return empty();
          }
          return ajax.get(response.next, headers);
        }),
        map((res) => {
          const Wmps: Wmp[] = res.response.results;
          return getWmps.success(Wmps);
        }),
        catchError((e) => of(getWmps.failure(e)))
      );
    })
  );
};

export default combineEpics(getWmpsEpic, throttledGetWmpsEpic);
